import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDownOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m12.9 18.554 6.827-6.827L21 13l-9 9-9-9 1.273-1.273 6.827 6.827V2h1.8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowDownOutlinedSize24Glyph.displayName = 'ArrowDownOutlinedSize24Glyph';
